import React from "react";

export function ThankYouMessage() {
    return (
        <div  className="wizardContainer">
            <h1><span className="text-orange">Cloudnexa</span> Preassessment</h1>
            <p className="wizardDescription">
                Need to modernize and secure your environment by moving to AWS? Complete Cloudnexa's Preassessment below and
                you will receive up to $60K in assessment funding for your entire cloud assessment journey!
            </p>
            <div className="wizardForm">
                <div className="wizardStepContainer ">
                    <div className="wizardStepForm">
                        <h2>
                            Thank You
                        </h2>
                        <p className="thankYouSubTitle">
                            Thank you for completing Cloudnexa's Preassessment.
                        </p>
                        <p className="thankYouDescription">
                            We look forward to talking with you about how Cloudnexa can help modernize and secure your environment
                            and how you can receive up to $60K in assessment funding for your cloud journey!
                        </p>
                    </div>

                </div>

            </div>
        </div>

    )
}